require('./openYoungFiscalDataStep1.scss');

// @ vendor
const React = require('react');
const PropTypes = require('prop-types');
const { FormattedText } = require('core/i18n').i18n;

// @components
const { OpenYoungTaxDataForm } = require('components/openYoungTaxDataForm/openYoungTaxDataForm');

class OpenYoungFiscalDataStep1 extends React.Component {

    render() {
        const {immOpenYoungTaxData} = this.props;
        return (
            <div className="open-young-fiscal-data-step-1">
                <FormattedText
                    className="open-young-fiscal-data-step-1__title"
                    value="openYoungFiscalData-openYoungFiscalData_step1Title"
                />
                <OpenYoungTaxDataForm
                    immOpenYoungTaxData={immOpenYoungTaxData}
                />
            </div>
        );
    }
}

OpenYoungFiscalDataStep1.propTypes = {
    immOpenYoungTaxData: PropTypes.object.isRequired,
};

module.exports = OpenYoungFiscalDataStep1;
